function nodeListToArray(nodelist) {
  let arr = [];
  try {
    arr = Array.prototype.slice.call(nodelist);
  } catch (error) {
    nodelist.forEach(node => {
      arr.push(node);
    });
  }
  return arr;
}
export default nodeListToArray;